import React from 'react'
import { Flex, Typography } from 'antd'
import { cn } from '@/utils/style.ts'
import { EmptyData } from '@/common/types/misc.def.ts'

type DetailItemProps = {
  label: string
  value: React.ReactNode
  icon?: React.ReactNode
}

export const DetailItem: React.FC<DetailItemProps> = ({ label, value, icon }) => {
  return (
    <div className="flex-1 min-w-[200px]">
      <Flex vertical gap={4}>
        <Flex align="center" gap={6}>
          {icon}
          <Typography.Text type="secondary" className="text-xs">
            {label}
          </Typography.Text>
        </Flex>
        {typeof value === 'string' ? (
          <Typography.Text className={cn("text-base font-base whitespace-pre-wrap", {
            'text-gray-300': !value || value === EmptyData.string
          })}>
            {value}
          </Typography.Text>
        ) : value}
      </Flex>
    </div>
  )
}